import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Hub } from "aws-amplify/utils";
import {
  signIn,
  signOut as amplifySignOut,
  signInWithRedirect,
} from "aws-amplify/auth";
import { Container, Form, Button, FloatingLabel, Alert } from "react-bootstrap";
import useForm from "../user/UseForm";
import { UserContext } from "../user/UserContext";
import { useDispatch } from "react-redux";
import { setIsSignedIn } from "../../redux/slices/authSlice";

export default function SignIn() {
  const { values, handleChange, handleSubmit, errors, setErrors } =
    useForm(handleSignIn); // Initialize useForm hook
  const navigate = useNavigate(); // Initialize useNavigate for navigation  const navigate = useNavigate(); // Initialize useNavigate for navigation
  const { updateUserAttributes } = React.useContext(UserContext); // Access updateUserAttributes from UserContext
  const dispatch = useDispatch(); // Initialize Redux dispatch function

  useEffect(() => {
    const unsubscribe = Hub.listen("auth", ({ payload }) => {
      switch (payload.event) {
        case "signIn":
          handleSuccessfulSignIn();
          break;
        case "signIn_failure":
          setErrors({ form: "Sign-in failed. Please try again." });
          break;
        default:
          break;
      }
    });

    return unsubscribe;
  });

  async function handleSuccessfulSignIn() {
    try {
      await updateUserAttributes(); // Update user attributes after successful sign-in
      dispatch(setIsSignedIn(true)); // Update the Redux state to indicate the user is signed in
      navigate("/"); // Navigate to the home page after successful sign-in
    } catch (error) {
      setErrors({ form: error.message }); // Set form error if sign-in fails
    }
  }

  // Function to handle regular sign-in process
  async function handleSignIn() {
    try {
      await amplifySignOut(); // Sign out any existing user session to ensure a clean start
      await signIn({
        username: values.username, // Use the email/username from form values
        password: values.password, // Use the password from form values
      });
      await handleSuccessfulSignIn(); // Directly call handleSuccessfulSignIn after a successful sign-in
    } catch (error) {
      setErrors({ form: error.message }); // Set form error if sign-in fails
    }
  }

  // Function to handle redirect to sign-up page
  function handleSignUpRedirect() {
    navigate("/signup"); // Navigate to the sign-up page
  }

  // Function to handle Google sign-in using redirect
  async function handleGoogleSignIn() {
    try {
      await signInWithRedirect({ provider: "Google" });
    } catch (error) {
      setErrors({ form: error.message }); // Handle errors during the OAuth flow
    }
  }

  return (
    <Container className="d-flex align-items-center justify-content-center py-4 min-vh-100">
      <Form className="form-signin w-100" onSubmit={handleSubmit}>
        <h1 className="h3 mb-3 fw-normal">Please sign in</h1>
        {/* Display error message if any */}
        {errors.form && <Alert variant="danger">{errors.form}</Alert>}
        <FloatingLabel
          controlId="floatingEmail"
          label="Email address"
          className="mb-3"
        >
          <Form.Control
            className="rounded-0 rounded-top mb-3"
            type="email"
            placeholder="name@example.com"
            name="username"
            value={values.username || ""} // Controlled input for username/email
            onChange={handleChange} // Update state on input change
            required
          />
        </FloatingLabel>
        <FloatingLabel
          controlId="floatingPassword"
          label="Password"
          className="mb-3"
        >
          <Form.Control
            className="rounded-0 rounded-bottom mb-3"
            type="password"
            placeholder="Password"
            name="password"
            value={values.password || ""} // Controlled input for password
            onChange={handleChange} // Update state on input change
            required
          />
        </FloatingLabel>
        <Form.Group className="mb-3" controlId="formBasicCheckbox">
          <Form.Check type="checkbox" label="Remember me" />
        </Form.Group>
        <Button className="w-100" variant="primary" type="submit">
          Sign In
        </Button>
        <Button
          className="w-100 mt-2"
          variant="secondary"
          onClick={handleSignUpRedirect} // Handle redirect to sign-up page
        >
          Sign Up
        </Button>
        <Button
          className="w-100 mt-2"
          variant="success"
          onClick={handleGoogleSignIn} // Handle Google sign-in
        >
          Sign In with Google
        </Button>
      </Form>
    </Container>
  );
}
